import { createAction, props } from '@ngrx/store';
import { PatientImmunizationGroup } from '../../models/patient-immunization-group';

export const getPatientImmunizations = createAction('[Immunizations] Get Patient Immunizations');

export const getPatientImmunizationsSuccess = createAction(
  '[Immunizations] Get Patient Immunizations Success',
  props<{ patientImmunizations: PatientImmunizationGroup[] | null }>()
);

export const getPatientImmunizationsFailure = createAction(
  '[Immunizations] Get Patient Immunizations Failure',
  props<{ error: unknown }>()
);

export const toggleShowAll = createAction('[Immunizations] Toggle Show All', props<{ cvxGroupName: string }>());

export const recordImmunizationPrintEvent = createAction(
  '[Immunizations] Record Print Event',
  props<{ patientId: number; patientImmunizationIds: number[] }>()
);

export const recordImmunizationPrintEventSuccess = createAction('[Immunizations] Record Print Event Success');

export const recordImmunizationPrintEventFailure = createAction(
  '[Immunizations] Record Print Event Failure',
  props<{ error: unknown }>()
);
